import ForgotPasswordContainer from './forgot_password_container';

const ForgotPassword = ForgotPasswordContainer;
export default ForgotPassword;
